import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const expenseBudgetDetails = createAsyncThunk("expenseBudget/details", async ({ premise_id, financial_year_id, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + "expense_budget",
            params: {
                premise_id: premise_id,
                year_id: financial_year_id,
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const saveExpenseBudget = createAsyncThunk("expenseBudget/save", async (data) => {

    const budgets = data?.values?.budgets?.map((val) => ({
        expense_budget_id: val?.id,
        expense_id: val?.expense_type_id,
        budget_amount: val?.budget_amount === "" || val?.budget_amount == null
            ? 0
            : Number(val?.budget_amount),
    }))

    try {
        const res = await axios({
            method: "POST",
            url: getConfig.API_URL + "expense_budget",
            data: {
                premise_id: data?.values?.premise_id,
                year_id: data?.values?.financial_year_id,
                budget_amount: budgets,
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const expenseBudget = createSlice({
    name: "expenseBudget",
    initialState: {
        details: [],
        loading: false,
    },
    reducers: {
        clearExpenseBudget: (state) => {
            state.details = []
        },
    },
    extraReducers: (builder) => {
        builder.addCase(expenseBudgetDetails.pending, (state) => {
            state.loading = true
        })
        builder.addCase(expenseBudgetDetails.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data ?? []
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
                state.details = []
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.details = []
            } else {
                state.details = []
            }
        })
        builder.addCase(expenseBudgetDetails.rejected, (state) => {
            state.loading = false
            state.details = []
        })
    },
})

export const { clearExpenseBudget } = expenseBudget.actions;
export default expenseBudget.reducer;